import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getGallectionDeviationStreamId } from '../helpers';
import { getCurrentMediaSource, getCurrentFolderId, getSearchQuery, getCurrentSubfolderId } from '../selectors';
export default function*() {
    const { mediaSource, folderId, subfolderId, searchQuery } = yield select((state)=>({
            mediaSource: getCurrentMediaSource(state),
            folderId: getCurrentFolderId(state),
            subfolderId: getCurrentSubfolderId(state),
            searchQuery: getSearchQuery(state)
        }));
    const streamId = getGallectionDeviationStreamId(mediaSource, subfolderId || folderId, searchQuery);
    const isFetching = yield select(selectors.isFetching, streamId);
    if (isFetching) {
        return;
    }
    yield put(withOffset.actions.fetch(streamId));
}
